import type { HyloServices, HttpClient, RequestOptions } from '@/model';
import {constantLive} from '@/model';
import { createSpacesFakeHttp } from './fake-http';
const wrappers = new WeakMap<HyloServices, HyloServices>();
/** The feature declares protocol 8 on its own requests; auth/refresh/headers remain core-owned. */
export function spacesServices(original: HyloServices): HyloServices {
    let wrapper = wrappers.get(original);
    if (wrapper)
        return wrapper;
    const fake=import.meta.env.DEV&&import.meta.env.VITE_HYLO_FAKE==='1';
    const source = fake ? createSpacesFakeHttp(original) : original.http;
    const options = (value?: RequestOptions): RequestOptions => ({ ...value, protocol: 8 });
    const http: HttpClient = {
        response: (method, path, value) => source.response(method, path, options(value)),
        uploadRaw: (path, bytes, value) => source.uploadRaw(path, bytes, value),
        request: (method, path, value) => source.request(method, path, options(value)),
        get: (path, value) => source.get(path, options(value)), post: (path, body, value) => source.post(path, body, options(value)),
        put: (path, body, value) => source.put(path, body, options(value)), patch: (path, body, value) => source.patch(path, body, options(value)),
        delete: (path, value) => source.delete(path, options(value)), blob: (path, value) => source.blob(path, options(value)),
        upload: (path, form, value) => source.upload(path, form, value),
    };
    const fakeFlags=fake?constantLive<Readonly<Record<string,unknown>>>({...original.flags.flags().get(),'projects.ui':true,'projects.organize':true}):undefined;
    wrapper = { ...original, http,...fakeFlags?{flags:{...original.flags,flags:()=>fakeFlags,isEnabled:key=>Boolean(fakeFlags.get()[key])}}:{} };
    wrappers.set(original, wrapper);
    return wrapper;
}
